import { useRecoilValue } from 'recoil';
import { usePrevious } from 'react-delta';
import { activeRequestTimeState } from 'components/common/Managers/RouteStateManager.state';

// Custom hook that returns a boolean if the current render is part of a new search (data request)
export const useIsNewSearch = () => {
  const requestTime = useRecoilValue(activeRequestTimeState);
  const prevRequestTime = usePrevious(requestTime);
  return requestTime !== prevRequestTime;
};
